import React, {useRef} from 'react';
import ModalsEnum from '../enums/modal.enum';
import {useDispatch, useSelector} from "react-redux";
import {closeModal} from "../redux/modal.slice";
import SignInModal from "./SignInModal";
import SignUpModal from "./SignUpModal";
import ResetPasswordModal from "./ResetPasswordModal";
import CheckEmailModal from "./CheckEmailModal";
import CheckEmailSignupModal from "./CheckEmailSignupModal";
import ChangePasswordModal from "./ChangePasswordModal";
import DeleteAccountModal from "./DeleteAccountModal";


const getModal = ({ modalId, modalData }) => {
    switch (modalId) {
        case ModalsEnum.SIGN_IN_MODAL:
            return <SignInModal />;
        case ModalsEnum.SIGN_UP_MODAL:
            return <SignUpModal />;
        case ModalsEnum.RESET_PASSWORD_MODAL:
            return <ResetPasswordModal modalData={modalData} />;
        case ModalsEnum.CHECK_EMAIL_MODAL:
            return <CheckEmailModal modalData={modalData} />;
        case ModalsEnum.CHECK_EMAIL_SIGNUP_MODAL:
            return <CheckEmailSignupModal modalData={modalData} />;
        case ModalsEnum.CHANGE_PASSWORD_MODAL:
            return <ChangePasswordModal modalData={modalData} />;
        case ModalsEnum.DELETE_ACCOUNT_MODAL:
            return <DeleteAccountModal modalData={modalData} />;
        default:return <></>;
    }
};


const Modal = (props) => {
    const modalClassName = useSelector((state) => state.modal?.modalData[0]?.className);
    const closeRef = useRef(null);
    const dispatch = useDispatch();

    const handleCloseModal = () => dispatch(closeModal())
    const handleBgCloseModal = () => {
        dispatch(closeModal());
    }

    return (
        <div className={`modal`}>
            <div className="modal-background" onClick={handleBgCloseModal} />
            <div className={`modal-inner ${modalClassName || ''}`} ref={closeRef}>
                {/*<button className="close-button" onClick={handleCloseModal}>*/}
                {/*    <i className='icon-close' />*/}
                {/*</button>*/}
                {getModal(props)}
            </div>
        </div>
    );
};

export default Modal;
